// src/api/bilanComptableApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Récupère le bilan comptable depuis l'API.
 * @returns {Promise<Object>} Objet contenant l'actif, le passif et le résultat.
 */
export const fetchBilanComptable = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/bilan-comptable`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du bilan comptable :", error);
    throw error;
  }
};
